module.exports = __webpack_public_path__ + "img/howtouse09.8d77b203.jpg";